<template>
  <div class="common-footer">
    <div class="row">
      <p>
        <a href="https://www.12377.cn/" target="_blank" style="margin-right: 30px;">
          <img src="@/assets/images/jubao1.jpg" alt="">
        </a>

        <a href="http://www.scjb.gov.cn/" target="_blank" style="margin-right: 30px;">
          <img src="@/assets/images/jubao4.jpg" alt=""></a>

        <a href="http://scpiyao.org.cn/" target="_blank" style="margin-right: 30px;">
          <img src="@/assets/images/zaoyao.png" alt=""></a>

        <a href="http://past.ybxww.com/gg/blxxjb/" target="_blank">
          <img src="@/assets/images/jubao5.jpg" alt="">
        </a>
      </p>
      <p>Copyright kb.news.csavs.com All Rights Reserved. 未经书面授权，不得复制或建立镜像</p>
      <p>新闻热线:  媒体运营:  行风监督:  违法和不良信息举报电话:  举报邮箱: </p>
      <p>互联网新闻信息服务许可证:  信息网络传播视听节目服务许可证:  <img src="@/assets/images/gwb.png">川公网安备
         地址: 四川省成都市武侯区吉庆四路交叉路口环球时代中心-C座 邮编: 
      </p>
      <p>主办单位名称: 创视科技 主办单位性质: 企业单位</p>
      <p>备案/许可证号: <a href="https://beian.miit.gov.cn" target="_blank"></a></p>
    </div>
  </div>
</template>

<script setup lang="ts">

</script>

<style lang="less" scoped>
.common-footer {
  width: 100%;
  margin-top: 130px;
  padding-top: 20px;
  background: #efefef;
  text-align: center;

  padding-bottom: 15px;

  .row {
    zoom: 1;
    width: 1400px;
    margin: 0 auto;

    P {
      font-size: 14px;
      color: #3d3d3d;
      margin-bottom: 12px;
    }
  }
}
</style>